import ExternalLinksBaseHandler from '../external_links_base_handler';
import {MY_ACCOUNT_POST_ACTIONS}  from './external_links_my_account_handler_consts';
import _ from '../../../../utils/underscore';
import * as EXTERNAL_LINKS_CONSTS from '../../external_links_consts';
import ServiceFactory from '../../../../services/service_factory';
import {NAVIGATION_VIEWS} from "../../external_links_consts";
import Device from "../../../../utils/device/device";
import {PRIORITY_LEVEL} from "../../../../services/overlay_manager/overlay_manager_levels";
import {Check} from "@sparkware/app-utils";


/**
 *
 */
class ExternalLinksMyAccountHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksMyAccountHandler';
    static HandlerName = 'my_account';

    /**
     * Overrides base class
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
        let postDataObjLower = _.toLowerCaseKeys(postMessageData);
        switch (postDataObjLower.actionid.toString()) {
			case MY_ACCOUNT_POST_ACTIONS.EXTERNAL_URL: //done
				let navView = Device.isMobile() ? NAVIGATION_VIEWS.IFRAME : NAVIGATION_VIEWS.WINDOW;
				/* 'addCloseOption' param is drilled down into external link component for add close overlay option.)
					now it's disabled by css for mobile external link overlay */
				this.openExternalLink({
                    sourceLink: this._getURLFromActionData(postMessageData),
                    addCloseOption: true,
                    view: navView,
                    priorityLevel: PRIORITY_LEVEL.INTERNAL_OVER_EXTERNAL_LINK
                });
				break;
            case MY_ACCOUNT_POST_ACTIONS.GAME:
                this.close();
                if (_.isUndefined(postDataObjLower.gameid) || _.isNull(postDataObjLower.gameid)) {
                    this.logger.warn('GameId is undefined or empty. Unable to open real game from MyAccount');
                    break;
                }
                this.openRealGame(postDataObjLower.gameid, postDataObjLower.origininformation.originDeepLinkID);
                break;
            case MY_ACCOUNT_POST_ACTIONS.RICH: //done
                this.close();
                let richPageUrl = ServiceFactory.create().integrationService().getRichPageUrl(postDataObjLower.campaignid);
                this._serviceFactory.windowService().redirect(richPageUrl);
                break;
            case MY_ACCOUNT_POST_ACTIONS.CASHIER: //done
                this._handleCashierOpening(postMessageData);
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.QUICK_DEPOSIT: //done
                this._handleQuickDeposit(postMessageData);
                this.close();
                break;
			case MY_ACCOUNT_POST_ACTIONS.SPORT: //done
				this.openExternalLink({
					source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.SPORT
				});
				this.close();
				break;
            case MY_ACCOUNT_POST_ACTIONS.CASINO: //done
                //SpecificNavigation should be used only from OMG
                if (postDataObjLower.specificnavigation) {
                    //add logic here
                }
                //TODO maybe it is prefer to check if we are on the same web site, and do not redirect in this case
                this._serviceFactory.windowService().redirect(ServiceFactory.create().integrationService().getLobbyUrlLink());
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.CLOSE: //done
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.INTERNAL_URL: //done
			    this._openInternalLink(postMessageData);
			    break;
            default:
                this.logger.warn('Not supported ActionID. ActionID = ' + postDataObjLower.actionid);
                break;
        }
    }



    getHandlerName() {
        return ExternalLinksMyAccountHandler.HandlerName;
    }


	/**
	 * Open Internal Link url over the same page
	 * @private
	 */
	_openInternalLink(postData) {
        const currentURL = this._getURLFromActionData(postData);
        if (currentURL) {
            //verify if it's internal url
            if (this._serviceFactory.windowService().getDomain() ===  this._serviceFactory.windowService().extractDomain(currentURL)) {
                this._serviceFactory.windowService().redirect(currentURL);
            } else {
                this.logger.error('Redirect to internal url ' + currentURL + ' has been prevented. ' + currentURL + ' is not an internal url of ' +  this._serviceFactory.windowService().getDomain());
            }
        }
        else {
            this.logger.error("Error in _openInternalLink: the received object did not contain an URL field.")
        }
	}

    _getURLFromActionData(data){
        const urlFieldName = Check.isObject(data)?Object.keys(data).find(name => name.toLowerCase()==="url"):null;
        return (urlFieldName?data[urlFieldName]:null);
    }
}

export default ExternalLinksMyAccountHandler;